import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'payment_methods';
export const route = 'payment_methods/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "paymentmethods" */
'../../components/PaymentMethods')));